import { useEffect } from 'react';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { useRouter } from 'next/router';
import { cleanHttpRefererFromStorage } from 'tracking/TrackingProvider';
import { useAvroTracking } from 'tracking';

export function NavigationTracker() {
  const trackEvent = useTrackEvent();
  const { emitPageViewEvent } = useAvroTracking();
  const router = useRouter();

  useEffect(() => {
    cleanHttpRefererFromStorage();

    const trackPageView = () => {
      // setTimeout for reasons of:
      // A) Give added time / tick for identity Cookie to be set (additional safety measure)
      // B) timneutkens does it in next-plugin-google-analytics for equivalent handler https://github.com/vercel/next.js/blob/5fff814ca1e7f78b50535a55d6f99bd842c4e049/packages/next-plugin-google-analytics/src/on-init-client.js
      setTimeout(() => {
        trackEvent('navigate_blog', {});
        emitPageViewEvent();
      }, 0);
    };

    const hasQueryParams = !!location.search;

    /**
     * 1) Track initial page view
     *
     * Next.js is triggering `routeChangeComplete` if the URL has query params in it
     * and that was causing us to track `navigate_blog` twice.
     *
     * We want to avoid double tracking for any campaign that we run.
     */
    if (!hasQueryParams) {
      trackPageView();
    }

    trackEvent('performance: mount', {
      timeToMount: window.performance.now(),
      timeToMountType: 'page-ready',
    });

    /**
     * 2) Track subsequent page views from client side navigation
     */
    router.events.on('routeChangeComplete', trackPageView);

    return () => {
      cleanHttpRefererFromStorage();
      router.events.off('routeChangeComplete', trackPageView);
    };
  }, []);

  return null;
}
